import { useState, useEffect } from 'react';
import { useLeaderboardStore } from '../store/leaderboardStore';
import type { User } from '../types/user';

export function useUser() {
  const addUserToLeaderboard = useLeaderboardStore(state => state.addUser);
  const [user, setUser] = useState<User | null>(() => {
    const savedUser = localStorage.getItem('kingdom-user');
    if (savedUser) {
      try {
        const parsedUser = JSON.parse(savedUser);
        // Validate the user data structure
        if (
          parsedUser &&
          typeof parsedUser.username === 'string' &&
          typeof parsedUser.walletAddress === 'string' &&
          typeof parsedUser.points === 'number'
        ) {
          return parsedUser;
        }
      } catch (error) {
        console.error('Failed to parse saved user data:', error);
      }
    }
    return null;
  });

  useEffect(() => {
    if (user) {
      try {
        localStorage.setItem('kingdom-user', JSON.stringify(user));
        addUserToLeaderboard(user);
      } catch (error) {
        console.error('Failed to save user data:', error);
      }
    } else {
      localStorage.removeItem('kingdom-user');
    }
  }, [user, addUserToLeaderboard]);

  const clearUser = () => {
    setUser(null);
    localStorage.removeItem('kingdom-user');
  };

  return [user, setUser, clearUser] as const;
}